export default __webpack_public_path__ + "static/media/sprt-pl3.818b4c73.png";